





import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IPolicy } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'policy-customer-short',
  components: {},
})
export default class PolicyCustomerShort extends mixins(BaseMixin) {
  @Prop({ type: Object, required: true })
  policy!: IPolicy;

  @Prop({ type: Boolean, required: false, default: true })
  small!: boolean;

  get customerName(): string {
    return (this.policy && this.policy.customer) || '';
  }
}
